
import {

  FETCH_TABLE_REQUEST,
  FETCH_TABLE_SUCCESS,
  FETCH_TABLE_FAILURE,
  FETCH_FLOORS_SUCCESS,

  CREATE_TABLE_REQUEST,
  CREATE_TABLE_SUCCESS,
  CREATE_TABLE_FAILURE,

  UPDATE_TABLE_REQUEST,
  UPDATE_TABLE_SUCCESS,
  UPDATE_TABLE_FAILURE,

  DELETE_TABLE_REQUEST,
  DELETE_TABLE_SUCCESS,
  DELETE_TABLE_FAILURE,
} from "./tableActionTypes";

const initialState = {
  tableData: [],
  loading: false,
  error: null,
  floors: [],
};

const tableReducer = (state = initialState, action) => {
  switch (action.type) {
 
    case FETCH_TABLE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_TABLE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        tableData: action.payload.data,
      };
    case FETCH_FLOORS_SUCCESS:
      return {
        ...state,
        loading: false,
        floors: action.payload,
      };
    case FETCH_TABLE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        tableData: [],
      };

    case CREATE_TABLE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case CREATE_TABLE_SUCCESS:
      return {
        ...state,
        loading: false,
        tableData: action.payload.data,
        error: null,
      };
    case CREATE_TABLE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_TABLE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case UPDATE_TABLE_SUCCESS:
      return {
        ...state,
        loading: false,
        tableData: action.payload.data,
        error: null,
      };
    case UPDATE_TABLE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DELETE_TABLE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case DELETE_TABLE_SUCCESS:
      return {
        ...state,
        loading: false,
        tableData: action.payload.data,
        error: null,
      };
    case DELETE_TABLE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default tableReducer;
